const React = require("react");

const {AdminInput, AdminInputPassword} = require("../../../../../../../dumb/FormInputs");
const {FormFooter, FormWrapper} = require("../../../../../../../dumb/FormHandlers");
const {apiAdminWithdrawComplete} = require("../../../../../../../../api/admin/withdraws");

const formSchema = require('./utils/formSchema');

module.exports = ({data, update, close}) => {

  const resultModalData = [
    'Withdrawal request completed',
    `You\'ve completed withdrawal request for #${data.id}.`
  ];

  const onSubmit = ({transaction_hash, confirmBearer, transaction_explorer_url}) => (
    apiAdminWithdrawComplete({
      withdraw_id: data.id,
      transaction_hash,
      confirmBearer,
      transaction_explorer_url
    })
  );

  const onResult = () => {
    update();
    close();
  }

  return (
    <FormWrapper
      data={{wallet_address: data.app_wallet.address}}
      schema={formSchema}
      onSubmit={onSubmit}
      resultModalData={resultModalData}
      onResult={onResult}
    >{(formCtx) => {
      return (
        <>
          <AdminInput name="transaction_hash" formCtx={formCtx} />
          <AdminInput name="transaction_explorer_url" formCtx={formCtx} />
          <AdminInputPassword label="Password" name="confirmBearer" formCtx={formCtx} />
          <FormFooter
            submitBtnData={{
              text: 'Complete',
              formCtx
            }}
            additionalBtnsList={[
              {
                text: 'Cancel',
                onClick: close
              }
            ]}
          />
        </>
      )
    }}</FormWrapper>
  )
}
